import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    fxRateRes: {}
};

export const fxRateSlice = createSlice({
    name: 'fxRate',
    initialState,
    reducers: {
        fxRateSuccess: (state, action) => {
            state.fxRateRes = action.payload
        },
        fxRateReset: (state) => {
            state.fxRateRes = {}
        }

    }
});

export const { fxRateReset, fxRateSuccess } = fxRateSlice.actions;

export default fxRateSlice.reducer;
